<script setup lang="ts">
import { useRoute } from '#app'
// types
import { Meta as MetaType } from 'zhead'
import type { Seo } from '@/types/main'
// stores
import { useCityStore } from '@/store/city/city'

type Props = {
  title?: string
  seo?: Seo
}

const props = defineProps<Props>()

const { path, fullPath } = useRoute()
const {
  cityInfo: { domain },
} = useCityStore()

const canonicalLink = `https://${domain}${path}`

const defaultTitle = computed(() => props?.title || props?.seo?.title)

const defaultMetaTags: MetaType[] = [
  {
    name: 'description',
    content: props?.seo?.description,
  },
  {
    name: 'keywords',
    content: props?.seo?.keywords,
  },
]

const ogMetaTags: MetaType[] = [
  {
    property: 'og:type',
    content: 'website',
  },
  {
    property: 'og:title',
    content: props?.seo?.title,
  },
  {
    property: 'og:description',
    content: props?.seo?.description,
  },
  {
    property: 'og:url',
    content: `https://${domain}${fullPath}`,
  },
  {
    property: 'og:image',
    content: `https://${domain}/farfor-og-image.png`,
  },
]
</script>

<template>
  <Head>
    <!--Default head tags-->
    <Title>{{ defaultTitle }}</Title>

    <!--Canonical link-->
    <Link rel="canonical" :href="canonicalLink" />

    <!--Default meta tags-->
    <template v-for="meta in defaultMetaTags" :key="meta.name">
      <Meta :name="meta.name" :content="meta.content" />
    </template>

    <!--Open graph meta tags-->
    <template v-for="meta in ogMetaTags" :key="meta.property">
      <Meta :property="meta.property" :content="meta.content" />
    </template>

    <!--TODO: Типизировать slot-ы в будущем, когда версия vue будет 3.3+ -->
    <slot name="default" />
  </Head>
</template>
